export const CONTRACT_AGREEMENT = '/contract/agreement/' as const
export const CONTRACT_AGREEMENT_ALL = `${CONTRACT_AGREEMENT}all` as const
export const CONTRACT_AGREEMENT_CURRENT = `${CONTRACT_AGREEMENT}get` as const
export const CONTRACT_AGREEMENT_ACCEPT = `${CONTRACT_AGREEMENT}accept` as const
export const CONTRACT_AGREEMENT_OPEN = `${CONTRACT_AGREEMENT}open` as const
export const CONTRACT_DOWNLOAD = `${CONTRACT_AGREEMENT}download` as const
